"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var isValidClause_1 = require("../../utils/isValidClause");
function getSectionCompletionStatus(sectionType, sectionClauseIds) {
    var focusedClauseId = store_1.default.inboxRulesEditState.focusedClauseId;
    // name section is a special case -- no clause Id
    if (sectionType == 'name') {
        if (focusedClauseId == 'name') {
            return 2 /* InProgress */;
        }
        else if (store_1.default.inboxRulesEditState.ruleName &&
            store_1.default.inboxRulesEditState.ruleName.trim().length > 0) {
            return 1 /* Complete */;
        }
        else {
            return 0 /* Incomplete */;
        }
    }
    if (sectionClauseIds.indexOf(focusedClauseId) > -1) {
        return 2 /* InProgress */;
    }
    else if (isValidClause_1.isValidSection(sectionType)) {
        return 1 /* Complete */;
    }
    else {
        return 0 /* Incomplete */;
    }
}
exports.default = getSectionCompletionStatus;
//# sourceMappingURL=getSectionCompletionStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getSectionCompletionStatus.js
// module id = 5209
// module chunks = 2